import { render, staticRenderFns } from "./tableau.vue?vue&type=template&id=69c27ffe&lang=pug&"
import script from "./tableau.vue?vue&type=script&lang=js&"
export * from "./tableau.vue?vue&type=script&lang=js&"
import style0 from "./tableau.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports